export default "__VITE_ASSET__92475a70__"